import { render, staticRenderFns } from "./CustomerMembershipBillings.vue?vue&type=template&id=454f0053&"
import script from "./CustomerMembershipBillings.vue?vue&type=script&lang=js&"
export * from "./CustomerMembershipBillings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports